export class DetailView {
  make(selector, biases) {
    this.selector = selector;
    this.biases = biases;
    this.path = location.pathname.replace(/^\//, '');
    this.deck = biases.get(this.path ? this.path : 0);
    this.detailed = $('.fallacy-detailed').extend({

      populate: function(bias) {
        this.show();
        this.find('h1').html(bias.title);
        this.find('h2').html(bias.head);
        this.find('.body p').first().html(bias.description);
        this.find('.body p').eq(1).html(bias.exampleText);

        // this.find('.body p').eq(3).html(`<span class="fb-like" data-href="${window.location.protocol}//${window.location.hostname}/${bias.slug}" data-layout="button_count" data-action="like" data-show-faces="true" data-share="true"></span>`);
        this.find('.body p').eq(3).html(`<div class="fb-share-button" data-href="${window.location.protocol}//${window.location.hostname}/${bias.slug}" data-layout="button" data-size="large" data-mobile-iframe="true"><a class="fb-xfbml-parse-ignore" target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=${window.location.protocol}//${window.location.hostname}/${bias.slug}&src=sdkpreparse">Share</a></div>`);
        let $square = this.find('.square-button');
        $square.find('i').attr('class', 'icon-'+bias.name);
        this.find('.body .further-reading').html(bias.furtherReading);
        let title = bias.meta.seo.title ? bias.meta.seo.title : bias.pageTitle;
        window.document.title = title;

        let desc = bias.meta.seo.description;
        $('meta[name="description"]').attr('content', desc);

        $.each(bias.meta.og, function(key, val) {
          $('meta[property="'+key+'"]').attr('content', val);
        });

        $('meta[property="og:url"]').attr('content', window.location.href);
      },

      change: function(bias, direction) {
        this.find('.square-button').velocity({
          opacity: 0,
          translateX: direction * -200 + 'px'
        }, 250);
        this.find('.body').velocity({
          opacity: 0,
          translateX: direction * -50 + 'px'
        }, 250, () => {
          this.populate(bias);
          this.find('.square-button').velocity({translateX: direction * 200 + 'px'}, 0);
          let squareButton = document.querySelector('.square-button');
          squareButton.innerHTML = '';
          bias.loadAnimation(squareButton, true);
          this.find('.body').velocity({translateX: direction * 50 + 'px'}, 0);
          this.find('.square-button, .body').velocity({
            opacity: 1,
            translateX: 0
          }, 250);
        });
      }
    });

    this.detailed.populate(this.deck);

    return this;
  }

  bindEvents(carousel) {
      carousel.elements.next.addEventListener('click', () => carousel.go('next'));
      carousel.elements.prev.addEventListener('click', () => carousel.go('prev'));
  }

  load(bias, advanced) {
    this.detailed.change(bias, this.deck === this.biases.prev(bias) ? 1 : -1);
    this.deck = bias;

    if (window.ga) {
      ga('send', 'pageview', this.path);
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/src/carousel/DetailView.js